import React from 'react'
import classNames from 'classnames'
import { Button } from '@toasttab/shared/src/components'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { UngatedCtaShortFormProps } from './UngatedCtaShortForm.d'

const UngatedCtaShortForm = (props: UngatedCtaShortFormProps) => {
  const image = props.ungatedIcon && props.ungatedIcon[0]
  const imageSizeCss = classNames({
    'h-[40px] w-[40px] mr-5': true
  })
  return (
    <section className='otl-ungated-cta-short-form mt-7 bg-otl-sand px-8 py-5 border-solid border-2 border-gray-200'>
      <div className='flex justify-between items-center'>
        <div className='flex items-center'>
          <div className={imageSizeCss}>
            <Image
              url={image.url}
              title={image.title}
              imageAlt={image.imageAlt}
              optimizedImages={image.optimizedImages}
              scaleHover={false}
            />
          </div>
          <div className='max-w-[350px] font-calibre'>{props.ungatedText}</div>
        </div>
        <Button
          href={
            props.ctaThankYouLink ? props.ctaThankYouLink : props.ungatedLink
          }
          variation='legacy'
          download
          arrowHover
        >
          Download
        </Button>
      </div>
      <div className='p-4 bg-toast-gray-0 flex justify-center'>
        <img
          src={resolvePrefix('/svg/img-toast-logo-gray.svg')}
          alt='Toast'
          className='mr-4'
        />
        <span>Built for Restaurants</span>
      </div>
    </section>
  )
}

export default UngatedCtaShortForm
